'use client'

import { StepContainer } from '@/components/steps/step-container'
import { StepHeader } from '@/components/steps/step-header'
import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'
import { useEffect, useRef } from 'react'
import * as Sentry from '@sentry/nextjs'
import { openIntercomChat } from '@/features/third-party/intercom/intercom-init'
import { useRouter } from 'next/navigation'
import { UrlConfig } from '@/setup/routing/routing'

export default function NotFoundPage() {
    const router = useRouter()

    const synced = useRef(false)
    useEffect(() => {
        if (synced.current) return

        synced.current = true

        Sentry.captureException(`The user is trying to access a page that doesn\'t exist. Url: ${window.location.href}`)
    }, [])

    return (
        <div className="flex flex-col justify-center items-center h-full pb-10 relative">
            <div className="flex flex-col h-full max-w-[390px] my-auto w-full justify-center">
                <StepHeader title="404 - Page not found" subtitle="We're sorry for the inconvenience." />

                <Card className="p-4 w-full">
                    <StepContainer>
                        <p className="text-[#737373] text-sm mb-3">
                            If you think this is an error, please contact support@superscale.ai.
                        </p>

                        <div className="flex flex-col-reverse items-center justify-center gap-2 md:flex-row md:ml-auto">
                            <Button
                                size="sm"
                                variant={'secondary'}
                                onClick={() => router.push(UrlConfig['/routing'].getUrl())}
                                className="w-full md:w-fit md:ml-auto"
                            >
                                Return to home
                            </Button>

                            <Button
                                size="sm"
                                variant={'secondary'}
                                onClick={() => {
                                    window.open('mailto:support@superscale.ai')
                                }}
                                className="w-full md:w-fit md:ml-auto"
                            >
                                Mail
                            </Button>

                            <Button
                                size="sm"
                                variant={'primary'}
                                onClick={() => {
                                    openIntercomChat()
                                }}
                                className="w-full md:w-fit md:ml-auto"
                            >
                                Chat with us
                            </Button>
                        </div>
                    </StepContainer>
                </Card>
            </div>
        </div>
    )
}
